export default __webpack_public_path__ + "static/media/navbar-two-factor-authentication-orange.6c644f37.svg";